<div class="container">

  <h2>Exercícios</h2>

  <form [formGroup]="form" (ngSubmit)="salvar()">
    <div class="form-floating mb-3">
      <select formControlName="tipo" class="form-control" (change)="onTipoChange($event)">
        <option *ngFor="let tipo of tiposExercicio" [value]="tipo.id">
          {{ tipo.nome }}
        </option>
      </select>
      <label for="floatingSelect">Tipo de exercício</label>
    </div>

    <div class="form-floating mb-3">
      <input formControlName="nome" class="form-control" id="floatingInput" placeholder="Nome">
      <label for="floatingInput">Nome</label>
    </div>

    <div class="form-floating mb-3">
      <input formControlName="video" class="form-control" id="floatingInput" placeholder="Video (URL)">
      <label for="floatingInput">Video (URL)</label>
    </div>
    <div class="form-floating mb-3">
      <textarea formControlName="comoExecutar" class="form-control" id="floatingTextarea" placeholder="Como executar"
        style="height: 120px"></textarea>
      <label for="floatingTextarea">Como executar</label>
    </div>
    <div class="d-flex gap-2 mt-3">
      <button type="submit" class="btn btn-primary">Salvar</button>
      <button type="button" (click)="novo()" class="btn btn-secondary">Novo</button>
    </div>
  </form>

  <hr>

  <table mat-table [dataSource]="dataSource" matSort class="mt-2">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Id"
        class="d-none d-lg-table-cell d-xl-table-cell d-xxl-table-cell">
        Id
      </th>
      <td mat-cell *matCellDef="let element" class="d-none d-lg-table-cell d-xl-table-cell d-xxl-table-cell">
        {{element.id}} </td>
    </ng-container>
    <ng-container matColumnDef="nome" class="">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Nome" class="">
        Nome Exercício
      </th>
      <td mat-cell *matCellDef="let element" class="d-lg-table-cell d-xl-table-cell d-xxl-table-cell">
        {{element.nome}} </td>
    </ng-container>
    <ng-container matColumnDef="tipo">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by tipo">
        Tipo Exercício
      </th>
      <td mat-cell *matCellDef="let element">{{ tiposExercicio.find(t => t.id === element.tipo)?.nome }}</td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <div class="btn-group" role="group" aria-label="Basic example">
          <button class="btn btn-sm" (click)="abrirImagens(row.id)">
            <i class="bi bi-image"></i>
          </button>
          <button class="btn btn-sm" (click)="editar(row, row.id)"><i class="bi bi-pen-fill"></i></button>
          <button class="btn btn-sm" (click)="remover(row.id)"><i class="bi bi-trash"></i></button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons aria-label="Selecione a página">
  </mat-paginator>

</div>